import Raven from 'raven-js';
import { useEffect } from 'react';
import CardListContainerFormatter from './CardListContainerFormatter';
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomContainerFormatter(props) {
  useEffect(() => {
    Raven.captureException(new Error('CustomContainerFormatter should not be rendered. Deferring to CardListContainerFormatter.'));
  }, []);
  return /*#__PURE__*/_jsx(CardListContainerFormatter, Object.assign({}, props));
}
export default CustomContainerFormatter;